<template>
  <a-modal
    :title="obj ? '编辑店铺' : '新增店铺'"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('hideModal')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="shopForm"
      :model="shopForm"
      :rules="shopFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="门店全称" prop="fullName">
        <a-input v-model="shopForm.fullName" placeholder="请填写全称，例：成都市青羊区汉庭酒店" />
      </a-form-model-item>

      <a-form-model-item label="门店展示名称" prop="displayName">
        <a-input v-model="shopForm.displayName" placeholder="请填写简称，例：汉庭酒店" />
      </a-form-model-item>
      <a-form-model-item label="门店编码" prop="sn">
        <a-input v-model="shopForm.sn" placeholder="请填写门店编码（统一社会信用代码或身份证号）" />
      </a-form-model-item>

      <a-form-model-item label="经营者名称" prop="operatorName">
        <a-input v-model="shopForm.operatorName" placeholder="请填写经营者名称" />
      </a-form-model-item>
      <a-form-model-item label="经营者手机号" prop="operatorPhone">
        <a-input v-model="shopForm.operatorPhone" placeholder="请填写经营者手机号" />
      </a-form-model-item>
      <a-form-model-item label="门店地址" prop="address">
        <a-input v-model="shopForm.address" placeholder="请填写门店地址" />
      </a-form-model-item>
      <a-form-model-item label="扩展参数" prop="exParam1">
        <a-textarea
          v-model="shopForm.exParam1"
          placeholder="请填写扩展参数"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import store from '@/store'

const enumsData = store.state.enumsStore.enumsData
/*
* 	门店地址		false
	门店扩展参数1		false
* 	*/
const shopForm = {
  id: undefined,
  displayName: undefined,
  fullName: undefined,
  operatorName: undefined,
  operatorPhone: undefined,
  sn: undefined,
  address: undefined,
  exParam1: undefined
}
const shopFormRules = {
  displayName: [{ required: true, message: '请填写门店名称！' }],
  fullName: [{ required: true, message: '请填写鱼住门店全称！' }],
  operatorName: [{ required: true, message: '请填写经营者名称！' }],
  sn: [{ required: true, message: '请填写门店编码' }]
}


export default {
  name: 'EditModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      shopForm,
      shopFormRules,
      adcOptions:[],
      templateList:[],
      industryList:[],
      uploading: false,
      confirmLoading:false,
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      if (val && this.obj){
        this.$nextTick(() => {
          let {  id,address,displayName,exParam1,fullName, operatorName, operatorPhone, sn }= this.obj
          this.shopForm = { id,address,displayName,exParam1,fullName, operatorName, operatorPhone, sn }
          console.log(this.shopForm )
        })
      }
    }
  },

  created() {
  },
  methods: {
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.shopForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.shopForm)
          this.confirmLoading = true
        }
      })
    },

    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.shopForm.resetFields()
      this.shopForm = shopForm
      this.confirmLoading = false
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
